"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const Tooltip_1 = __importDefault(require("../../Tooltip/Tooltip"));
const useIsOverflowing_1 = __importDefault(require("../../../hooks/useIsOverflowing"));
const constants_1 = require("../../../constants");
require("./AlertBannerText.scss");
const TOOLTIP_SHOW_TRIGGERS = [constants_1.HideShowEvent.MOUSE_ENTER];
const TOOLTIP_HIDE_TRIGGERS = [constants_1.HideShowEvent.MOUSE_LEAVE];
const AlertBannerText = ({ text, marginLeft = false }) => {
    const componentRef = (0, react_1.useRef)(null);
    const classNames = (0, classnames_1.default)("monday-style-alert-banner-text", { "monday-style-alert-banner-text-margin-left": marginLeft });
    const isOverflowing = (0, useIsOverflowing_1.default)({ ref: componentRef });
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ position: "bottom", content: isOverflowing && text, showTrigger: TOOLTIP_SHOW_TRIGGERS, hideTrigger: TOOLTIP_HIDE_TRIGGERS }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ ref: componentRef, className: classNames }, { children: (0, jsx_runtime_1.jsx)("span", { children: text }) })) })));
};
Object.assign(AlertBannerText, {
    isAlertBannerItem: true,
    isAlertBannerText: true
});
exports.default = AlertBannerText;
